import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchGetLocation } from '@/microfrontends/filters/shared/services/fetchGetLocation';
import { type TLocation } from '@/microfrontends/filters/shared/types/location';

import { type TThunkApi } from '../../types';

interface IUpdateLocationParameters {
  regionId: number;
}

interface IUpdateLocationResult {
  prev: TLocation;
  next: TLocation;
}

export const updateLocation = createAsyncThunk<IUpdateLocationResult, IUpdateLocationParameters, TThunkApi>(
  'location/update',
  async (parameters, thunkApi) => {
    const { rejectWithValue, extra, getState } = thunkApi;

    const prevLocation = getState().location;
    const locationResult = await fetchGetLocation(extra, parameters, { subdomain: extra.custom.subdomain });

    return locationResult
      .map(nextLocation => ({ prev: prevLocation.data, next: nextLocation.data }))
      .unwrapOrElse(rejectWithValue);
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.location.status !== 'loading';
    },
  },
);
